export const colors = {
  BC1: 'rgba(249, 249, 249, 0.92)',
  BC2: '#f6f6f6',
  BC3: '#fbfbfb',
  BC5: 'rgba(0, 0, 0, 0.59)',
  BC6: '#8ab67c',
  BC7: '#0089ec',

  C1: '#4d4d4d',
  C2: '#fff',
  C3: '#4a90e2',
  C3a: '#3e7bc2',
  C4: '#313f4f',
  C4a: '#485e77',
  C5: '#ff331e',

  BD1: '#e7e7e7',
  BD2: '#d1d1d1'
};



// WEBPACK FOOTER //
// ./styles/core/tradeShow.color.style.js